import React from 'react';
import cx from 'classnames';
import { Content as TabsContent } from '@radix-ui/react-tabs';
import { TabPanelsTreeNodeDataProps } from '@mutiny-pkg/champaign-schemas/src/schemas/flexiblePages/flexiblePagesTreeNode';
import { TabGroupContext } from './TabGroup';

type TabPanelsProps = {
  id: string;
  editorClassName?: string;
  children: React.ReactNode;
  isEditor?: boolean;
} & TabPanelsTreeNodeDataProps;

export const TabPanels = React.forwardRef<HTMLDivElement, TabPanelsProps>(
  (
    {
      id,
      className,
      editorClassName,
      children,
      isEditor = false,
      // `type` is a tree-node schema discriminator, not a DOM attribute.
      type: _type,
      ...props
    },
    ref,
  ) => {
    const ctx = React.useContext(TabGroupContext);
    const activeIndex = ctx?.activeIndex ?? 0;
    const panelIds = ctx?.panelIds ?? [];
    const childArray = React.Children.toArray(children);

    return (
      <div ref={ref} id={id} className={cx(className, editorClassName)} {...props}>
        {childArray.map((child, index) => {
          const hidden = index !== activeIndex;
          const key = panelIds[index] ?? index;
          return isEditor ? (
            <TabsContent key={key} value={`tab-${index}`} forceMount hidden={hidden}>
              {child}
            </TabsContent>
          ) : (
            <TabsContent key={key} value={`tab-${index}`} forceMount asChild hidden={hidden}>
              {child}
            </TabsContent>
          );
        })}
      </div>
    );
  },
);

TabPanels.displayName = 'TabPanels';
